import {
  isLibraryInOut,
  isTemplateHideOperation,
} from '@festina/configuration-general-types/configuration'
import type { BranchKey } from '@festina-life/api'
import { dateUtils, type Optional } from '@festina-life/core'

import type { ShadowedOperationsMap } from '../../workspace/operationsContext'
import { LocationAwareOperationLink } from '../configurationOperationLink/LocationAwareOperationLink'

type Props = {
  conflicts: ShadowedOperationsMap
  branch: BranchKey
  workspaceName?: Optional<string>
}

export const ShadowedTemplateLinks = ({
  conflicts,
  branch,
  workspaceName,
}: Props) =>
  Array.from(conflicts.entries()).flatMap(([block, layeredConflicts]) =>
    Array.from(layeredConflicts.entries()).map(
      ([layer, shadowedOperationsForLayer]) =>
        Array.from(shadowedOperationsForLayer.entries()).map(
          ([templateId, shadowedDatesWithOperations]) =>
            Array.from(shadowedDatesWithOperations.entries()).map(
              ([shadowedDate, operations]) => {
                const type = operations.some(
                  (value) =>
                    !isTemplateHideOperation(value.internalOperation) &&
                    isLibraryInOut(value.internalOperation.entity),
                )
                  ? 'library'
                  : 'template'

                const isSomeOperationDraft = operations.some(
                  (operation) => operation.isDraft,
                )

                return (
                  <LocationAwareOperationLink
                    key={`${block}-${layer.toString()}-${templateId}-${shadowedDate}`}
                    layer={layer}
                    block={block}
                    itemId={templateId}
                    type={type}
                    workspaceKey={
                      workspaceName
                        ? { name: workspaceName, branchKey: branch }
                        : undefined
                    } // If there's no operation then the operation belongs to the branch and not the workspace
                    branchKey={branch}
                    fromDate={
                      shadowedDate
                        ? dateUtils.dateUtcAsLocal(shadowedDate).toDate()
                        : undefined
                    }
                    conflictCount={operations.length - 1}
                    isDraft={isSomeOperationDraft}
                  />
                )
              },
            ),
        ),
    ),
  )
